import moment from "moment";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";

const DatePickerEditor = forwardRef((props, ref) => {
    const inputRef = useRef();
    const [value, setValue] = useState(props.value);

    function inputHandler(e) {
        setValue(e.target.value);
    }

    useEffect(() => {
        if(!props.value){
            setValue(moment(props.data.endDate).format('YYYY-MM-DD'))
        }
    },[props])

    useImperativeHandle(ref, () => {
        return {
            getValue: () => {
                return value;
            },
            afterGuiAttached: () => {
                setValue(props.value);
                inputRef.current.focus();
                inputRef.current.select();
            }
        };
    });

    return (
        <input
            type="date"
            className="ag-input-field-input "
            ref={inputRef}
            format="yyyy-mm-dd"
            pattern="\d{4}-\d{2}-\d{2}"
            onChange={inputHandler}
            value={value}
            placeholder="YYYY-MM-DD"
        />
    )
});

export default DatePickerEditor